/*import "./ButtonEditPage.css";
import ProgressBar from "../ProgressBar/ProgressBar";
import { useState } from "react";
const ButtonEditPage = (props) => {
  const [isProgressBarOpen, setIisProgressBarOpen] = useState(false);
  const openProgressBar = () => {
    setIisProgressBarOpen(true);
  };
  const closeProgressBar = () => {
    setIisProgressBarOpen(false);
  };
  const handleProgressBarClick = () => {
    closeProgressBar();
  };

  return (
    <>
      <div className="button-cls" style={props.style} onClick={openProgressBar}>
        {isProgressBarOpen && <ProgressBar onClick={handleProgressBarClick} />}
        {props.title}
      </div>
    </>
  );
};
export default ButtonEditPage;*/
import React, { useState } from "react";
import "./ButtonEditPage.css";
import ProgressBar from "../ProgressBar/ProgressBar";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import ButtonCardHOD from "../buttonCardHOD/buttonCardHOD";

const ButtonEditPage = (props) => {
  const { id } = useParams();
  const navigation = useNavigate();
  const [hodFlag, setHodFlag] = React.useState(null);
  const [isProgressBarOpen, setIsProgressBarOpen] = useState(false);
  const onSubmit = () => {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("jwt")} `,
      },
      body: JSON.stringify({ data: { comment: "" } }),
    };
    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/report/${id}/submit`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        const department = localStorage.getItem("departmentId");
        const role = localStorage.getItem("role");
        const editRoutes = {
          AUTONOMOUS: "/autonomous",
          PLACEMENT: `/placement `,
          PA: `/pa `,
          ACADEMIC: `/academic `,
          COE: `/coe `,
          IQAC: `/dean `,
          NCC: `/ncc `,
          NSS: `/nss `,
          PED: `/ped`,
          ADMINISTRATOR: `/administrator`,
          ACCOUNT:`/account`
        };

        const roleEditRoutes = {
          REPRESENTATIVE: `/representative `,
          HOD: `/hod `,
          ADMIN: `/Admin`,
        };

        if (role === "REPRESENTATIVE" && department in editRoutes) {
          navigation(editRoutes[department]);
        } else {
          navigation(roleEditRoutes[role]);
        }
      });
  };
  const toggleProgressBar = () => {
    if (props.title === "Progress") {
      setIsProgressBarOpen((prevState) => !prevState);
    } else if (props.title === "Submit") {
      onSubmit();
    } else if (props.title === "Actions") {
      setHodFlag(true);
    }
  };
  const closeAction = () => {
    setHodFlag(false);
  };

  return (
    <div>
      <div
        className="button-cls"
        style={props.style}
        onClick={toggleProgressBar}
      >
        {isProgressBarOpen && <ProgressBar onClose={toggleProgressBar} />}
        {props.title}
      </div>
      {hodFlag == true ? <ButtonCardHOD actionClose={closeAction} /> : null}
    </div>
  );
};

export default ButtonEditPage;
